import url from './urls'

const state = {
  isLoading: false,
  rules: null,
  judgeCates: null,
  judgeList: null,
  categoriesList: null,
  categoriesDetail: null,
  links: null
}

const mutations = {
  GETRULES (state) {
    state.isLoading = true

    fetch(url.awards.rules)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.rules = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETJUDGECATE (state) {
    state.isLoading = true

    fetch(url.awards.judge.category)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.judgeCates = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETJUDGELIST (state, id) {
    state.isLoading = true
    state.judgeList = []

    fetch(url.awards.judge.list + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.judgeList = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETCATELIST (state) {
    state.isLoading = true

    fetch(url.awards.categories.list)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.categoriesList = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETCATEDETAIL (state, id) {
    state.categoriesDetail = []
    state.isLoading = true

    fetch(url.awards.categories.detail + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.categoriesDetail = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETLINKS (state) {
    state.isLoading = true

    fetch(url.awards.categories.link)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.links = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getRules ({ commit }) {
    commit('GETRULES')
  },

  getJudgeCate ({ commit }) {
    commit('GETJUDGECATE')
  },

  getJudgeList ({ commit }, id) {
    commit('GETJUDGELIST', id)
  },

  getCateList ({ commit }) {
    commit('GETCATELIST')
  },

  getCateDetail ({ commit }, id) {
    commit('GETCATEDETAIL', id)
  },

  getLinks ({ commit }) {
    commit('GETLINKS')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
